@if ({
  mainContent: mainContent$ | async,
  }; as content) {
  <div class="container-simple-viewer-image-modal">
    @if (content.mainContent?.type === GALLERY_MEDIA_TYPE.IMAGES) {
      @if (content.mainContent?.content?.superZoom?.url || content.mainContent?.content?.zoom?.url) {
        <img [src]="content.mainContent?.content?.superZoom?.url || content.mainContent?.content?.zoom?.url" [alt]="" />
      } @else {
        <cx-media [container]="" tabindex="0" [format]="'superZoom'"></cx-media>
      }
    }
  </div>
}
